import { z } from "zod";
export const oauthCompleteRequestSchema = z.object({
    query: z.string().min(1),
});
export const oauthCompleteResponseSchema = z.object({
    redirect_to: z.url(),
});
export const oauthClientInfoQuerySchema = z.object({
    client_id: z.string().min(1),
});
export const oauthPropsSchema = z.object({
    user_id: z.string().min(1),
});
export const oauthClientInfoSchema = z.object({
    client_name: z.string().nullable(),
    client_uri: z.string().nullable(),
    redirect_uris: z.array(z.string()),
});
